"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("HubStyleTokens/colors");

var _PageConstants = require("./PageConstants");

var _UIAbstractPageGridContent = _interopRequireDefault(require("./UIAbstractPageGridContent"));

var _UIAbstractPageSection = _interopRequireDefault(require("./UIAbstractPageSection"));

var _UIPage = _interopRequireDefault(require("./UIPage"));

var _UIHeader = _interopRequireDefault(require("../layout/UIHeader"));

var CustomRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _NavHeight = require("../utils/NavHeight");

var _Styles = require("../utils/Styles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1; /* Only needed for IE11: #1992 */\n  background-color: ", ";\n  min-height: calc(100vh - ", ");\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function mainWrapperBackgroundColor(color) {
  return {
    backgroundColor: color
  };
}

function getBodyClassNames(bodyClassName, pageLayout) {
  return (0, _classnames.default)('space-sword', bodyClassName, {
    'space-sword--max-width': pageLayout === 'max-width'
  });
}

var StyledPage = (0, _styledComponents.default)(function (props) {
  var __navHeight = props.navHeight,
      rest = (0, _objectWithoutProperties2.default)(props, ["navHeight"]);
  return _react.default.createElement(_UIPage.default, rest);
}).withConfig({
  displayName: "UIAbstractPageTemplate__StyledPage",
  componentId: "rpoqcz-0"
})(_templateObject(), _colors.OLAF, function (_ref) {
  var navHeight = _ref.navHeight;
  return (0, _Styles.toPx)(navHeight);
});

function UIAbstractPageTemplate(_ref2) {
  var asDevice = _ref2.asDevice,
      bodyClassName = _ref2.bodyClassName,
      children = _ref2.children,
      className = _ref2.className,
      contentAreaFlush = _ref2.contentAreaFlush,
      headerComponent = _ref2.headerComponent,
      horizontalDivider = _ref2.horizontalDivider,
      narrowLayout = _ref2.narrowLayout,
      MainSection = _ref2.MainSection,
      mainSectionBackgroundColor = _ref2.mainSectionBackgroundColor,
      mainSectionStyle = _ref2.mainSectionStyle,
      navHeight = _ref2.navHeight,
      pageBackgroundColor = _ref2.pageBackgroundColor,
      pageLayout = _ref2.pageLayout,
      pageMaxWidth = _ref2.pageMaxWidth,
      pageStyle = _ref2.pageStyle,
      sidebarComponent = _ref2.sidebarComponent,
      stickySidebar = _ref2.stickySidebar,
      tabs = _ref2.tabs,
      title = _ref2.title,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["asDevice", "bodyClassName", "children", "className", "contentAreaFlush", "headerComponent", "horizontalDivider", "narrowLayout", "MainSection", "mainSectionBackgroundColor", "mainSectionStyle", "navHeight", "pageBackgroundColor", "pageLayout", "pageMaxWidth", "pageStyle", "sidebarComponent", "stickySidebar", "tabs", "title"]);
  var headerUse = tabs ? 'condensed' : undefined;
  var headerWrapperClassNames = (0, _classnames.default)('private-template__section--header');
  var mainWrapperClassNames = (0, _classnames.default)('private-template__section--stretch', {
    'private-template__section--divided': horizontalDivider,
    'private-template--narrow': narrowLayout
  });
  var pageClassName = (0, _classnames.default)('private-template', _PageConstants.DEVICE_CLASSES[asDevice], _PageConstants.LAYOUT_CLASSES[pageLayout], className);
  var sectionClassNames = (0, _classnames.default)({
    'private-template__section--spaced-vertical': !contentAreaFlush,
    'private-template__section--flush': contentAreaFlush
  });

  var templateBackgroundColor = function templateBackgroundColor(color) {
    return {
      backgroundColor: color
    };
  };

  var templateMaxWidth = function templateMaxWidth(width) {
    if (!width) return null;
    return {
      maxWidth: width
    };
  };

  return _react.default.createElement("div", {
    className: "private-ie11-flex-wrapper"
  }, _react.default.createElement(StyledPage, (0, _extends2.default)({}, rest, {
    bodyClassName: getBodyClassNames(bodyClassName, pageLayout),
    className: pageClassName,
    navHeight: (0, _lazyEval.default)(navHeight),
    style: (0, _extends2.default)({}, templateBackgroundColor(pageBackgroundColor), pageStyle)
  }), _react.default.createElement(_UIAbstractPageSection.default, {
    className: headerWrapperClassNames,
    style: (0, _extends2.default)({}, templateMaxWidth(pageMaxWidth))
  }, CustomRenderer.render(headerComponent, {
    title: title,
    use: headerUse
  }), tabs), _react.default.createElement("div", {
    className: mainWrapperClassNames,
    style: (0, _extends2.default)({}, mainWrapperBackgroundColor(mainSectionBackgroundColor), mainSectionStyle)
  }, _react.default.createElement(_UIAbstractPageSection.default, {
    className: sectionClassNames,
    style: (0, _extends2.default)({}, templateMaxWidth(pageMaxWidth))
  }, _react.default.createElement(MainSection, {
    sidebarComponent: sidebarComponent,
    stickySidebar: stickySidebar,
    style: (0, _extends2.default)({}, mainWrapperBackgroundColor(mainSectionBackgroundColor), mainSectionStyle)
  }, children)))));
}

UIAbstractPageTemplate.propTypes = {
  asDevice: _propTypes.default.oneOf(['mobile', 'tablet', 'desktop']),
  bodyClassName: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  contentAreaFlush: _propTypes.default.bool.isRequired,
  horizontalDivider: _propTypes.default.bool.isRequired,
  headerComponent: CustomRenderer.propType,
  MainSection: _component.default,
  mainSectionBackgroundColor: _propTypes.default.string,
  mainSectionComponent: CustomRenderer.propType,
  mainSectionStyle: _propTypes.default.object,
  narrowLayout: _propTypes.default.bool.isRequired,
  navHeight: (0, _createLazyPropType.default)(_propTypes.default.number).isRequired,
  pageBackgroundColor: _propTypes.default.string,
  pageLayout: _propTypes.default.oneOf(Object.keys(_PageConstants.LAYOUT_CLASSES)),
  pageMaxWidth: _propTypes.default.number,
  pageStyle: _propTypes.default.object,
  sidebarComponent: CustomRenderer.propType,
  stickySidebar: _propTypes.default.bool,
  tabs: _propTypes.default.node,
  title: _propTypes.default.node
};
UIAbstractPageTemplate.defaultProps = {
  contentAreaFlush: false,
  headerComponent: _UIHeader.default,
  horizontalDivider: false,
  MainSection: _UIAbstractPageGridContent.default,
  narrowLayout: false,
  navHeight: _NavHeight.getDefaultNavHeight,
  pageLayout: 'max-width',
  stickySidebar: false
};
UIAbstractPageTemplate.displayName = 'UIAbstractPageTemplate';
var _default = UIAbstractPageTemplate;
exports.default = _default;
module.exports = exports.default;